import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import { Button, Col } from "react-bootstrap";
import {
  form,
  Form as AppForm,
  FormRow,
  Select,
  CurrencyField
} from "MODULES/shared/components/Forms";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";

const formName = "updateQuarterlyGoalForm";

export function EditForm(props) {
  const { setEditingQuarterlyGoal } = props;
  const currentYear = moment().year();
  const years = [0, 1, 2].map(n => ({
    text: currentYear + n,
    value: currentYear + n
  }));
  const quarters = [1, 2, 3, 4].map(n => ({ text: `Quarter ${n}`, value: n }));

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={3}>
            <Field
              name="year"
              component={Select}
              options={years}
              label="Year"
              required
              disabled
            />
          </Col>
          <Col md={3}>
            <Field
              name="quarter"
              component={Select}
              options={quarters}
              label="Quarter"
              required
              disabled
            />
          </Col>
          <Col md={2}>
            <CurrencyField name="amount" label="Amount" required />
          </Col>
          <Col md={4} />
        </FormRow>
      </AppForm.Body>
      <AppForm.Footer
        style={{
          width: "calc(100% + 50px)",
          marginLeft: "-25px",
          paddingBottom: "0"
        }}
      >
        <Button onClick={() => setEditingQuarterlyGoal(null)}>Cancel</Button>
        <Button type="submit" bsStyle="primary">
          Save
        </Button>
      </AppForm.Footer>
    </AppForm>
  );
}

EditForm.propTypes = {
  setEditingQuarterlyGoal: PropTypes.func.isRequired,
  quarterlyGoal: PropTypes.shape({
    id: PropTypes.number.isRequired,
    year: PropTypes.number.isRequired,
    quarter: PropTypes.number.isRequired,
    amount: PropTypes.string.isRequired
  }),
  searchQuarterlyGoals: PropTypes.func.isRequired
};

export default connect(undefined, {})(
  form({
    form: formName,
    onSubmit: async (data, _, props) => {
      await api.quarterlyGoals
        .update(props.quarterlyGoal.id, data)
        .then(() => {
          props.searchQuarterlyGoals();
          props.setEditingQuarterlyGoal(false);
          return SUCCESS;
        })
        .catch(() =>
          toastr.error(
            "Error",
            "Couldn't add quarterly goal. Please ensure there is no quarterly goal for the selected year and quarter."
          )
        );
    }
  })(EditForm)
);



// WEBPACK FOOTER //
// ./app/modules/QuarterlyGoals/EditForm.jsx